import { Link } from "react-router-dom";

export default function ProfileCreateFooter({ className = "" }) {
  const year = new Date().getFullYear();

  return (
    <footer className={`text-center text-xs text-slate-500 ${className}`.trim()}>
      <p className="mb-2">
        <Link
          to="/terms"
          className="font-medium text-slate-600 transition hover:text-slate-900"
        >
          Terms &amp; Conditions
        </Link>
        <span className="mx-1.5 text-slate-300" aria-hidden>
          ·
        </span>
        <Link
          to="/privacy"
          className="font-medium text-slate-600 transition hover:text-slate-900"
        >
          Privacy Policy
        </Link>
      </p>
      <p className="mb-0 text-slate-400">© {year} EzePulse. All rights reserved.</p>
    </footer>
  );
}
